import React from 'react';
import { Routes, Route } from 'react-router-dom';
import UserNavbar from '../components/UserNavbar';
import AdminDashboard from '../pages/admin/AdminDashboard';
import BusinessForm from '../pages/BusinessForm';
const AdminLayout = () => {
    return (
        <div className="min-h-screen bg-gray-100">
            <UserNavbar />
            <main className="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
                <Routes>
                    <Route path="/" element={<AdminDashboard />} />
                    <Route path="/business/new" element={<BusinessForm />} />
                    <Route path="/business/edit/:id" element={<BusinessForm />} />
                </Routes>
            </main>
        </div>
    );
};

export default AdminLayout;